module.exports = __webpack_public_path__ + "static/img/headerbg.2b79d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/electricity/headerbg.png
// module id = 7Epg
// module chunks = 1